export default "__VITE_ASSET__09cf111c__"